<template>
  <div class="analysis-view">
    <a-row :gutter=16>
      <a-col :span="2">
        <div class="step-card step1-full-height">
          Step1: <br> Data selection
        </div>
      </a-col>
      <a-col :span="22">  
        <a-card class="option-card">
          <a-row :gutter=16>
            <a-col :span="9">
              <a-row style="margin-bottom: 20px;">
                <span class="param-title">
                  Omics data:
                </span>
                <a-select v-model="dataType" placeholder="Select data list" size="large" style="width: 64%;" :options="dataList" @change="handleChange">
                </a-select>
              </a-row>
              <a-row type="flex" justify="end">
                <a-col :span="5">
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>Confirm the sequencing data and sample group you have selected.</span>
                    </template>
                    <a-button type="primary" @click="handleConfirm" size="large">Confirm</a-button>
                  </a-tooltip>
                </a-col>
                <a-col :span="5">
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>Clear all selection and re-select.</span>
                    </template>
                    <a-button @click="handleClear" size="large">Clear</a-button>
                  </a-tooltip>
                </a-col>
              </a-row>
            </a-col>
            <a-col :span="15">
              <data-list ref="myTable"></data-list>
            </a-col>
          </a-row>
        </a-card>
      </a-col>
    </a-row>

    <a-row :gutter=16 class="mt-20" style="margin-top: 20px;">
      <a-col :span="2">
        <div class="step-card step2-color step2-full-height">
          Step2: <br> Analysis selection
        </div>
      </a-col>
      <a-col :span="22">
        <a-card class="option-card">
          <whole-trans-analysis v-if="confirmedDataType=='Whole transcriptome'"></whole-trans-analysis>
          <protome-analysis v-else-if="confirmedDataType=='Protome'"></protome-analysis>
          <ace-analysis v-else-if="confirmedDataType=='Acetylome'"></ace-analysis>
          <lac-analysis v-else-if="confirmedDataType=='Lactylome'"></lac-analysis>
          <pho-analysis v-else-if="confirmedDataType=='Phosphorylome'"></pho-analysis>
          <div v-else class="tbd-div step2-full-height">
            Please select a data list and click the confirm button.
          </div>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import WholeTransAnalysis from '@/components/WholeTransAnalysis.vue';
import ProtomeAnalysis from '@/components/ProtomeAnalysis.vue';
import AceAnalysis from '@/components/AceAnalysis.vue';
import LacAnalysis from '@/components/LacAnalysis.vue';
import PhoAnalysis from '@/components/PhoAnalysis.vue';
import DataList from '@/components/DataList.vue';

export default {
  name: 'AnalysisView',
  data() {
    return {
      nonTNBC: 'no',
      group: [],
      timeSeries: 'no',
      dataType: 'Whole transcriptome',
      confirmedDataType: 'Whole transcriptome'
    }
  },
  computed: {
    dataList() {
      var options = [
        {value:'Whole transcriptome', label: 'Whole transcriptome'},
        {value:'Acetylome', label: 'Acetylome'},
        {value:'Lactylome', label: 'Lactylome'},
        {value:'Protome', label: 'Protome'},
        {value:'Phosphorylome', label: 'Phosphorylome'}
      ]
      if (this.nonTNBC === 'yes') {
        options = options.slice(0, 3)
      }
      if (this.group.includes('treatment')) {
        options = options.slice(0, 3)
      }
      if (this.group.includes('control')) {
        return [
          {value:'Whole transcriptome', label: 'Whole transcriptome'}
        ]
      }
      if (this.timeSeries === 'yes') {
        return [
          {value:'Whole transcriptome', label: 'Whole transcriptome'}
        ]
      }
      return options
    },
    commaSeparatedItems() {
      return this.dataList.map(item => item.label).join(', ');
    }
  },
  components: {
    WholeTransAnalysis,
    DataList,
    ProtomeAnalysis,
    AceAnalysis,
    LacAnalysis,
    PhoAnalysis,
  },
    methods: {
      handleConfirm() {
        this.confirmedDataType = this.dataType
      },
      handleClear() {
        this.nonTNBC = 'no'
        this.group = []
        this.timeSeries = 'no'
        this.dataType = undefined
        this.confirmedDataType = this.dataType
        this.$refs.myTable.clearSelection()
      },
      handleChange(item) {
        console.log(item)
        switch(item) {
            case 'Whole transcriptome':
              this.$refs.myTable.highlightRow(['1','2'])
                break;
            case 'Acetylome':
            this.$refs.myTable.highlightRow(['3'])
                break;
            case 'Lactylome':
            this.$refs.myTable.highlightRow(['4'])
                break;
            case 'Protome':
            this.$refs.myTable.highlightRow(['5'])
                break;
            case 'Phosphorylome':
            this.$refs.myTable.highlightRow(['6'])
                break;
            default:
        } 
      }
    },
}
</script>

<style scoped>
.optional-select {
  padding-bottom: 10px;
  margin-left: 30px;
  padding-left: 15px;
  border-left: 2px solid rgba(128, 128, 128, 0.401);
  color: rgba(128, 128, 128, 0.401);
}

.analysis-view {
  padding: 20px;
}

.step-card {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  border: 1px solid #26a69a;
  border-radius: 8px;
  padding: 24px;
  text-align: center;
  font-weight: bold;
  height: 100%;
}

.step1-full-height {
  background-color: #8a56d318;
  height: 347px; /* Adjust to match the right side card height */
}

.step2-color {
  background-color: rgba(255, 192, 203, 0.411);
}

.step2-full-height {
  height: 750px; /* Adjust to match the right side card height */
}

.option-card {
  border: 1px solid #42a5f5;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-left: 10px;
}

.param-title {
  padding: 20px;
  font-size: 20px;
  font-weight: 500;
  color: black;
}

.param-text {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.597);
}

.mt-20 {
  margin-top: 20px;
}

.tbd-div {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  text-align: center;
  font-weight: bold;
  font-size: 24px;
  margin: -24px;
}
</style>
